/*
 *  
 * This component is the Item Holds page component. The component displays the Item Holds page details.
 * 
 * App Name: SDI-Walmart
 * Author: Dhevanesam R
 * Created Date: 01/18/2022
 */
import React, { Component } from 'react';
import * as ItemHoldsAction from '../actions/ItemHoldsAction';
import ItemHoldsStore from '../stores/ItemHoldsStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import ReactPaginate from 'react-paginate';
import SDIConstants from '../SDIConstants';
import { withTranslation, Trans } from 'react-i18next';
import * as MenuAction from '../actions/MenuAction';
import * as SearchResultsAction from '../actions/SearchResultsAction';
import swal from 'sweetalert';
let currentPagePath;

class ItemHoldsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isFavorited: false,
            ItemCount: 10,
            PageNo: 1,
            GridArray: [],
            GridCheckArray: [],
            SearchGridArray: [],
            SearchGridCheckArray: [],
            totalCount: 0,
            pageCount: 0,
            Itemtxt: "",
            WOtxt: "",
            WOmsg: false,
        }
        this.keyPress = this.keyPress.bind(this);
    }

    componentDidMount() {
        //WW-628_PC_01 (3/13/2023)-Aparna
        if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != null && CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != undefined && CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != " " && CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != "") {
            if (localStorage.getItem("ShipToID") != null) {
                //$("#WONUM").addClass("disabledbutton");
                //$("#WOOK").addClass("disabledbutton");

                $('#WONUM').val(JSON.parse(localStorage.getItem("WONum")))
            }
            CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            currentPagePath = this.props.location.pathname;
            currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
            let getFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            };
            ItemHoldsAction.getCurrentFavPage(getFavPageBO);
            this.PageLoad();
        }
        else {
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }
        ItemHoldsStore.on('PageLoad', this.PageLoadResponse);
        ItemHoldsStore.on('favpage', this.loadFavPageResponse.bind(this));
        ItemHoldsStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
        ItemHoldsStore.on('Update', this.UpdateButtonResponse);
        ItemHoldsStore.on('Search', this.SearchButtonResponse);
        ItemHoldsStore.on('PutOnHold', this.PutOnHoldButtonResponse);
        ItemHoldsStore.on('workordercheck', this.Workorderresponse);
        ItemHoldsStore.on('WOfail', this.workorderfail);
    }
    componentWillUnmount() {
        ItemHoldsStore.removeListener('PageLoad', this.PageLoadResponse);
        ItemHoldsStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        ItemHoldsStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));
        ItemHoldsStore.removeListener('Update', this.UpdateButtonResponse);
        ItemHoldsStore.removeListener('Search', this.SearchButtonResponse);
        ItemHoldsStore.removeListener('PutOnHold', this.PutOnHoldButtonResponse);
        ItemHoldsStore.removeListener('workordercheck', this.Workorderresponse);
        ItemHoldsStore.removeListener('WOfail', this.workorderfail);
    }
    //[01/18/2022, PC_IH_19, WW-320, Dhevanesam R]
    //This method is used to load the fav page icon based on the response
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(ItemHoldsStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    //[01/18/2022, PC_IH_36, WW-320, Dhevanesam R]
    //This method is used to update the fav page icon based on the response
    updateFavPageResponse = () => {
        if (ItemHoldsStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(ItemHoldsStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(ItemHoldsStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        this.refreshMenu();
    };
    //[01/18/2022, PC_IH_37, WW-320, Dhevanesam R]
    //This method is used to refresh the menu
    refreshMenu = () => {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            isRequestorApproval: CookieService.getLocalStorageValues("hasReqApprovalCheck"),
            isOrderApproval: CookieService.getLocalStorageValues("hasOrderApprovalCheck"),
            isFavItem: CookieService.getLocalStorageValues("hasFavItemCheck"),
            isFavOrder: CookieService.getLocalStorageValues("hasFavOrderCheck"),
            isFirstTime: false,
            IsWeb: true//isFirstTimeLoaded
        };
        console.log("masterBO", masterBO);
        MenuAction.getMasterData(masterBO);
    };
    //[01/18/2022, PC_IH_21, WW-320, Dhevanesam R]
    //This method is used to handle the fav icon
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Item Holds",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Crib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") //WW-628_PC_02 (3/13/2023)-Aparna
            }
            ItemHoldsAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            ItemHoldsAction.deleteFavPage(deleteFavPageBO)
        }
    };
    //[01/18/2022, PC_IH_39, WW-320, Dhevanesam R]
    //This Method is used to invoke the pageload method in API to get grid values
    PageLoad = () => {
        let PageLoadDataBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            PageNo: this.state.PageNo,
            ItemCount: this.state.ItemCount,
            Crib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") //WW-628_PC_02 (3/13/2023)-Aparna
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        ItemHoldsAction.PageLoad(PageLoadDataBO);

    }
    //[01/18/2022, PC_IH_46, WW-320, Dhevanesam R]
    //This Method is used to get the grid values based on the response
    PageLoadResponse = () => {
        //if (localStorage.getItem("ShipToID") != null) {
        //    $("#WONUM").addClass("disabledbutton");
        //}
        let BindGrid = JSON.parse(ItemHoldsStore.PageLoad);
        let BindGridData = BindGrid.GridLoadValue;
        if (BindGridData.length > 0) {
            let tc = BindGrid.TotalCount[0].TOTAL_COUNT

            BindGridData.forEach((value, index) => {
                value.Gridchecked = false;
            });
            //console.log("BindGridData", BindGridData)
            //let BindGridData1 = BindGridData
            //BindGridData.forEach((value, index) => {
            //    
            //    let valueof = value.INV_ITEM_ID.substring(0, 1)
            //    console.log("valueof", valueof)
            //    if (value.INV_ITEM_ID.trim().substring(0, 1).toUpperCase() == "W") {

            //    }
            //    else {
            //        BindGridData.splice(index, 1)
            //    }
            //});

            let GridcheckedData = this.state.GridCheckArray
            if (GridcheckedData.length > 0) {

                GridcheckedData.forEach((Checkvalue, index) => {

                    BindGridData.forEach((value, index) => {

                        if (value.INV_ITEM_ID === Checkvalue.INV_ITEM_ID && value.BUSINESS_UNIT == Checkvalue.BUSINESS_UNIT) {
                            value.Gridchecked = true;
                        }
                    });
                });
            }
            this.setState({
                GridArray: BindGridData,
                totalCount: tc,
                pageCount: Math.ceil((tc > 0 ? tc : 0) / this.state.ItemCount),
                Itemtxt: ""
            });

        }
        else {
            this.setState({
                GridArray: [], totalCount: 0, Itemtxt: ""
            });
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    //[01/18/2022, PC_IH_48, WW-320, Dhevanesam R]
    //This Method is used to bind the grid values
    BindGridData = () => {
        console.log("GridArray1", this.state.GridArray);
        return this.state.GridArray.map((val, index) => {
            console.log("GridArray2", this.state.GridArray);
            let IHarray = this.state.GridArray;
            return (<React.Fragment key={`key${index}`}>
                <tr>
                    <td className="d-sm-none d-md-table-cell">

                        <div className="col-md-1 float-left text-center px-0">
                            <div className="custom-control custom-checkbox item-custom-control">
                                <input type="checkbox" className="custom-control-input" checked={val.Gridchecked} id={`ItemHolds${index + 1}`} name={`example1`} onChange={() => this.selectUpdateItemOnChange(val)} />
                                <label className="custom-control-label" htmlFor={`ItemHolds${index + 1}`} />
                            </div>
                        </div>
                    </td>
                    <td className="d-sm-none d-md-table-cell">{val.BUSINESS_UNIT}</td>
                    <td className="d-none d-sm-none d-md-table-cell">{val.INV_ITEM_ID}</td>
                    <td className="d-sm-none d-md-table-cell">{val.DESCR}</td>
                </tr>
            </React.Fragment>);

        })
    };
    //[01/18/2022, PC_IH_80, WW-320, Dhevanesam R]
    //This Method is used to handle the page click
    handlePageClick = (data) => {

        let pageNo = data.selected + 1;
        this.setState({ PageNo: pageNo });
        let PageLoadDataBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            PageNo: pageNo,
            ItemCount: this.state.ItemCount,
            Crib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") //WW-628_PC_02 (3/13/2023)-Aparna
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        ItemHoldsAction.PageLoad(PageLoadDataBO);
    };
    //[01/18/2022, PC_IH_50, WW-320, Dhevanesam R]
    //This Method is used to check and uncheck the grid items checkbox 
    selectUpdateItemOnChange = (ind) => {

        let { GridArray } = this.state;
        let locGridCheck = this.state.GridCheckArray;
        let filtarray;
        if (locGridCheck.length > 0) {

            filtarray = locGridCheck.findIndex(t => (t.INV_ITEM_ID === ind.INV_ITEM_ID && t.BUSINESS_UNIT == ind.BUSINESS_UNIT));
        }
        let I = GridArray.findIndex(t => (t.INV_ITEM_ID === ind.INV_ITEM_ID && t.BUSINESS_UNIT == ind.BUSINESS_UNIT))
        GridArray[I].Gridchecked = GridArray[I].Gridchecked == true ? false : GridArray[I].Gridchecked == false ? true : true;
        if (GridArray[I].Gridchecked == true) {
            if (filtarray == -1 || filtarray == undefined) {

                locGridCheck.push(GridArray[I]);
            }
        }
        else {
            locGridCheck.splice(filtarray, 1)
        }
        if (locGridCheck.length > 0) {

            locGridCheck = locGridCheck.filter((selected) => selected.Gridchecked == true);
        }
        this.setState({ GridCheckArray: locGridCheck });
        this.setState(GridArray);
    }
    //[01/18/2022, PC_IH_50, WW-320, Dhevanesam R]
    //This Method is used to uncheck the grid items selected in the grid
    CancelButtonClick = (e) => {

        let BindGridData = this.state.GridArray
        BindGridData.forEach((value, index) => {
            value.Gridchecked = false;
        });
        this.setState({ GridCheckArray: [], GridArray: BindGridData, Itemtxt: "" });
    }
    //[01/18/2022, PC_IH_50, WW-320, Dhevanesam R]
    //This Method is used to redirect to home page
    CancelRedirectButtonClick = (e) => {
        this.props.history.push({
            pathname: "/HomePage",
        });
    }

    //[01/18/2022, PC_IH_51, WW-320, Dhevanesam R]
    //This Method is used to invoke the update method in API to update the selected grid items 
    UpdateButtonClick = () => {


        let HoldItems = this.state.GridCheckArray;
        let itemsSelected = this.state.GridCheckArray.filter((selected) => selected.Gridchecked == true);
        let itemsToAdd = [];
        if (itemsSelected.length > 0) {
            itemsSelected.forEach((value) => {
                itemsToAdd.push({
                    ItemID: value.INV_ITEM_ID,
                    BusinessUnit: value.BUSINESS_UNIT,
                    Description: value.DESCR
                });

            });
            let UpdateLoadDataBO = {
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                LineItems: itemsToAdd,
                Crib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") //WW-628_PC_02 (3/13/2023)-Aparna
            }; //;
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ItemHoldsAction.UpdateData(UpdateLoadDataBO);
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select any item to Unhold"
            });
            // alert("Please select any item to Unhold");
        }
    }
    //[01/18/2022, PC_IH_58, WW-320, Dhevanesam R]
    //This Method is used to get the updated grid items response and to invoke the pageload method in API to get grid values
    UpdateButtonResponse = () => {

        let UpdatedData = JSON.parse(ItemHoldsStore.Update);
        let UpdateGridData = UpdatedData.SuccessMessage;
        if (UpdateGridData.length > 0) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: UpdateGridData[0].UpdateSuccess
            });
            //alert(UpdateGridData[0].UpdateSuccess)

            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            if (UpdateGridData[0].UpdateSuccess == "Items Unhold successfully.") {
                this.setState({ GridCheckArray: [], Itemtxt: "", PageNo: 1 });
            }
            else {
                this.setState({ PageNo: 1 });
            }
            let PageLoadDataBO = {
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                PageNo: "1",
                ItemCount: this.state.ItemCount,
                Crib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") //WW-628_PC_02 (3/13/2023)-Aparna
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');

            ItemHoldsAction.PageLoad(PageLoadDataBO);
        }
    }
    //[01/18/2022, PC_IH_59, WW-320, Dhevanesam R]
    //This Method is used to handle the search item textbox
    keyPress(e) {
        if (e.keyCode == 13) {
            ;
            let ItemId = $('#ItemID').val();
            if (ItemId.trim() != "") {
                this.SearchButtonClick();
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please enter the valid item ID "
                });
                //alert("Please enter the inventory Item ID to search");
            }

        }
    }
    //[01/18/2022, PC_IH_59, WW-320, Dhevanesam R]
    //This Method is used to invoke the search method in API to search the respective item entered in the search textbox
    SearchButtonClick = () => {
        //let BindGridData = this.state.GridArray
        //BindGridData.forEach((value, index) => {
        //    value.Gridchecked = false;
        //});
        //this.setState({ GridCheckArray: [], GridArray: BindGridData, Itemtxt: "" });
        console.log("shiptovalitem", localStorage.getItem("StoreValue"))

        let WOnumsearch = $('#WONUM').val();
        if (WOnumsearch != undefined) {
            WOnumsearch = WOnumsearch.trim()
        }
        //[02/23/2022, PC_IH_01, WBW - 9, Dhevanesam R]
        let ItemId = $('#ItemID').val();
        if (ItemId != undefined) {
            ItemId = ItemId.trim()
        }
        if (ItemId != "") {
            if (ItemId.substring(0, 1).toUpperCase() == "W") {

                let SearchLoadDataBO = {
                    ItemID: ItemId,
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                    Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                    Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                    Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                    Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                    Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                    Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                    Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                    Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                    Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                    Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                    WorkOrder: localStorage.getItem("WONum") != null ? JSON.parse(localStorage.getItem("WONum")) : "",
                    ShipToID: localStorage.getItem("StoreValue") != null ? JSON.parse(localStorage.getItem("StoreValue")) : "",
                    Location: CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "",
                    Crib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") //WW-628_PC_02 (3/13/2023)-Aparna
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ItemHoldsAction.SearchLoad(SearchLoadDataBO);
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please provide a valid item ID "
                });
                // alert("Please enter the inventory Item ID to search");
                this.setState({ Itemtxt: "" });
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please provide a valid item ID "
            });
            //alert("Please enter the inventory Item ID to search");
        }

    }
    //[01/18/2022, PC_IH_59, WW-320, Dhevanesam R]
    //This Method is used to set state the entered values in the search box 
    getItemSearchText = (e) => {
        let searchVal = e.target.value;
        this.setState({ Itemtxt: searchVal });
    }
    ClearSearch = () => {
        this.setState({ Itemtxt : ""})
    }
    //[01/18/2022, PC_IH_66, WW-320, Dhevanesam R]
    //This Method is used to get the searched item response to display in search pop up or to invoke the pageload method in API to get grid values
    SearchButtonResponse = () => {
        let SearchData = JSON.parse(ItemHoldsStore.Search);
        let SearchGridData = SearchData.FailureMessage;
        if (SearchGridData.length > 0) {

            if (SearchGridData[0].FailureMessage == "") {
                let SearchGridDataVal = SearchData.Result;
                if (SearchGridDataVal.length > 0) {

                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    $('#search-details-IH').modal('show');
                    SearchGridDataVal.forEach((value, index) => {
                        value.SearchGridchecked = false;
                    });
                    this.setState({ SearchGridArray: SearchGridDataVal });

                }
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: SearchGridData[0].FailureMessage
                });
                // alert(SearchGridData[0].FailureMessage)
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                $('#search-details-IH').modal('hide');
                this.setState({ GridCheckArray: [], Itemtxt: "" });
                let PageLoadDataBO = {
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    PageNo: "1",
                    ItemCount: this.state.ItemCount,
                    Crib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") //WW-628_PC_02 (3/13/2023)-Aparna
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');

                ItemHoldsAction.PageLoad(PageLoadDataBO);
            }
        }
    }
    //[01/18/2022, PC_IH_68, WW-320, Dhevanesam R]
    //This Method is used to bind the searched item in the search pop up based on the response
    BindSearchGridData = () => {
        console.log("SearchGridArray", this.state.SearchGridArray);
        return this.state.SearchGridArray.map((val, index) => {
            console.log("SearchGridArray2", this.state.GridArray);
            let IHSearcharray = this.state.SearchGridArray;
            return (<React.Fragment key={`key${index}`}>
                <tr>
                    <td className="d-md-table-cell">

                        <div className="col-md-1 float-left text-center px-0">
                            <div className="custom-control custom-checkbox item-custom-control">
                                <input type="checkbox" className="custom-control-input" checked={val.SearchGridchecked} id={`ItemHoldsSearch${index + 1}`} name={`example1`} onChange={() => this.selectPutItemOnChange(val)} />
                                <label className="custom-control-label" htmlFor={`ItemHoldsSearch${index + 1}`} />
                            </div>
                        </div>
                    </td>
                    <td className="d-md-table-cell">{val.BUSINESS_UNIT}</td>
                    <td className="d-md-table-cell">{val.customerPartnumber}</td>
                    <td className="d-md-table-cell">{val.Description}</td>
                </tr>
            </React.Fragment>);

        })
    };
    //[01/18/2022, PC_IH_70, WW-320, Dhevanesam R]
    //This Method is used to check and uncheck the search grid items checkbox 
    selectPutItemOnChange = (ind) => {
        let { SearchGridArray } = this.state;
        let locSearchGridCheck = this.state.SearchGridCheckArray;
        let filtarray;
        if (locSearchGridCheck.length > 0) {

            filtarray = locSearchGridCheck.findIndex(t => (t.INV_ITEM_ID === ind.INV_ITEM_ID && t.BUSINESS_UNIT == ind.BUSINESS_UNIT));
        }
        let I = SearchGridArray.findIndex(t => (t.INV_ITEM_ID === ind.INV_ITEM_ID && t.BUSINESS_UNIT == ind.BUSINESS_UNIT))
        SearchGridArray[I].SearchGridchecked = SearchGridArray[I].SearchGridchecked == true ? false : SearchGridArray[I].SearchGridchecked == false ? true : true;
        if (SearchGridArray[I].SearchGridchecked == true) {
            if (filtarray == -1 || filtarray == undefined) {

                locSearchGridCheck.push(SearchGridArray[I]);
            }

        }
        if (locSearchGridCheck.length > 0) {

            locSearchGridCheck = locSearchGridCheck.filter((selected) => selected.SearchGridchecked == true);
        }
        this.setState({ SearchGridCheckArray: locSearchGridCheck });
        this.setState(SearchGridArray);
    }
    //[01/18/2022, PC_IH_70, WW-320, Dhevanesam R]
    //This Method is used to close the search pop up
    SearchPopUpclose = (e) => {
        $('#search-details-IH').modal('hide');
        this.setState({ Itemtxt: "", SearchGridCheckArray: [] });
    }
    //[01/18/2022, PC_IH_71, WW-320, Dhevanesam R]
    //This Method is used to invoke the put on hold method in API to add the item in the grid for being hold
    PutOnHoldButtonClick = () => {
        let PutHoldItems = this.state.SearchGridCheckArray;
        let itemsSelected = this.state.SearchGridCheckArray.filter((selected) => selected.SearchGridchecked == true);
        let putitemsToAdd = [];
        if (itemsSelected.length > 0) {
            itemsSelected.forEach((value) => {
                putitemsToAdd.push({
                    ItemID: value.customerPartnumber,
                    BusinessUnit: value.BUSINESS_UNIT,
                    Description: value.Description
                });

            });
            let PutOnHoldBO = {
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                LineItems: putitemsToAdd,
                Crib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") //WW-628_PC_02 (3/13/2023)-Aparna
            }; //;
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ItemHoldsAction.PutOnHoldItems(PutOnHoldBO);
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please choose an item for holding."
            });
            // alert("Please select any item to put on hold");
            $('#search-details-IH').modal('show');
        }
    }
    //[01/18/2022, PC_IH_78, WW-320, Dhevanesam R]
    //This Method is used to get the put on hold item response and to invoke the pageload method in API to get grid values
    PutOnHoldButtonResponse = () => {
        let PutOnHoldData = JSON.parse(ItemHoldsStore.PutOnHold);
        let PutOnHoldGridData = PutOnHoldData.SuccessPutMessage;
        if (PutOnHoldGridData.length > 0) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: PutOnHoldGridData[0].PutOnHoldSuccess
            });
            // alert(PutOnHoldGridData[0].PutOnHoldSuccess)

            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            this.setState({ GridCheckArray: [], SearchGridCheckArray: [], PageNo: 1 });
            $('#search-details-IH').modal('hide');
            //if (PutOnHoldGridData[0].PutOnHoldSuccess == "No Items added to hold.") {
            //    
            //    this.setState({ GridCheckArray: [], SearchGridCheckArray: [] });
            //    $('#search-details-IH').modal('hide');
            //}
            let PageLoadDataBO = {
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                PageNo: "1",
                ItemCount: this.state.ItemCount,
                Crib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") //WW-628_PC_02 (3/13/2023)-Aparna
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');

            ItemHoldsAction.PageLoad(PageLoadDataBO);
        }
    }
    //[01/18/2022, PC_IH_78, WW-320, Dhevanesam R]
    //This Method is used to uncheck the search grid items selected in the grid
    CancelPutOnHoldButtonClick = (e) => {
        let BindSearchGridData = this.state.SearchGridArray
        BindSearchGridData.forEach((value, index) => {
            value.SearchGridchecked = false;
        });
        $('#search-details-IH').modal('show');
        this.setState({ SearchGridCheckArray: [], SearchGridArray: BindSearchGridData });
    }
    //[01/18/2022, PC_IH_59, WW-320, Dhevanesam R]
    //This Method is used to open the work order number pop up
    WOpopup = () => {
        $('#WorkOrder').modal('show');
        this.setState({ Itemtxt: "", SearchGridCheckArray: [], WOmsg: false });
    }
    //[01/18/2022, PC_IH_59, WW-320, Dhevanesam R]
    //This Method is used to close the work order number pop up
    WOClose = () => {
        $('#WorkOrder').modal('hide');
        this.setState({ Itemtxt: "", SearchGridCheckArray: [], WOmsg: false });
    }
    //handleWOnum = (e) => {
    //    let WOVal = e.target.value;
    //    this.setState({ WOtxt: WOVal });
    //}
    //[01/18/2022, PC_IH_59, WW-320, Dhevanesam R]
    //This Method is used to invoke the work order number validation method in API
    WOClick = () => {
        this.setState({ Itemtxt: "", SearchGridCheckArray: [] });
        let WorkOrderNo = $('#WONUM').val()
        if (WorkOrderNo != "" && WorkOrderNo != null && WorkOrderNo != undefined) {
            let THIRDPARTY_COMP_ID = ""
            if (CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null) {
                THIRDPARTY_COMP_ID = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
            }
            let BO = {
                workOrder: WorkOrderNo,
                Session_THIRDPARTY_COMP_ID: THIRDPARTY_COMP_ID
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            SearchResultsAction.supplierOrderEntryPageLoad(BO)
        }
        else {

            this.setState({ WOmsg: true });
            return;
        }
    }
    //[01/18/2022, PC_IH_59, WW-320, Dhevanesam R]
    //This Method is used to assign the local storage values based on work order number response
    Workorderresponse = () => {

        let Workorderresponse = JSON.parse(ItemHoldsStore.workorderresponse);
        let localasset = "";
        let workorder = [];
        let localstore = "";
        let storeval = "";
        let localWON = $('#WONUM').val();
        let loacalloc = "";
        let LWOmsg = false;
        let BilltoStoreLocationLat = 0;
        let BilltoStoreLocationLong = 0;
        let BilltoStore = "";
        let lat = 0;
        let long = 0;
        console.log("workorder", Workorderresponse);
        if (Workorderresponse) {
            if (Workorderresponse.length > 0) {
                workorder = Workorderresponse;
                let homestoreloc = CookieService.getLocalStorageValues("LOCATION");
                CookieService.updateLocalStorageValues("homestoreloc", homestoreloc);
                CookieService.updateLocalStorageValues("LOCATION", Workorderresponse[0].COUNTRY);
                CookieService.updateLocalStorageValues("Session_STATE", Workorderresponse[0].STATE);
                if (Workorderresponse[0].LOCATION != "" && Workorderresponse[0].LOCATION != null && Workorderresponse[0].LOCATION != undefined && Workorderresponse[0].LOCATION != " ") {
                    loacalloc = Workorderresponse[0].LOCATION;
                    storeval = Workorderresponse[0].DESCR;
                    BilltoStoreLocationLat = Workorderresponse[0].LATITUDE;
                    BilltoStoreLocationLong = Workorderresponse[0].LONGITUDE;
                    BilltoStore = Workorderresponse[0].DESCR_AC;
                    if (loacalloc != null && loacalloc != undefined) {
                        localStorage.setItem("ShipToID", JSON.stringify(loacalloc));
                        localStorage.setItem("WONum", JSON.stringify(localWON));
                        localStorage.setItem("StoreValue", JSON.stringify(loacalloc));
                        localStorage.setItem("BilltoStoreLocationLat", BilltoStoreLocationLat);
                        localStorage.setItem("BilltoStoreLocationLong", BilltoStoreLocationLong);
                        localStorage.setItem("BiltoStoreValue", BilltoStore);
                        localStorage.setItem("Country", Workorderresponse[0].COUNTRY);

                    }
                    $('#WorkOrder').modal('hide');
                    let PageLoadDataBO = {
                        Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                        PageNo: "1",
                        ItemCount: this.state.ItemCount,
                        Crib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") //WW-628_PC_02 (3/13/2023)-Aparna
                    }
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');

                    ItemHoldsAction.PageLoad(PageLoadDataBO);
                    this.setState({
                        WOmsg: false, WOtxt: localWON,
                    })

                }
                else {

                    this.setState({ WOmsg: true })
                }
            } else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Enter valid Work Order Number"
                });

                //   alert("Enter valid Work Order Number")
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Enter valid Work Order Number"
            });
            // alert("Enter valid Work Order Number")
        }
    }
    //[01/18/2022, PC_IH_59, WW-320, Dhevanesam R]
    //This Method is used to display the validation msg of work order number response
    workorderfail = () => {
        swal({
            allowOutsideClick: false,
            closeOnClickOutside: false,
            text: "Enter valid Work Order Number"
        });
        //  alert("Enter valid Work Order Number");
        this.setState({ WOmsg: true })
        $(`#WONUM`).val('');
    }
    render() {
        console.log("WOmsgclick1", this.state.WOmsg)
        return (
            <div>
                <div className="container-fluid content-section custom-mb">  {/* Jeyanth - Replaced - content-margin cctop */}
                    <div className="row">
                        <div className="col-md-12 page-heading">
                            <h5 className="page-title"><Trans>Item Holds</Trans></h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-Fav" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-Fav">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>
                        </div>

                        <div className="col-md-12 my-3">
                            <div className="row align-items-center">
                                <div className="col-md-2 mb-3">
                                    <label className="catalog-label mb-0"><Trans>Business unit : </Trans></label>
                                    <label className="catalog-label mb-0">I0W01</label>
                                </div>
                                <div className="col-md-12 col-lg-3 mb-3">
                                    <div className="row">
                                        <label className="col-md-6 col-sm-4 col-lg-3 catalog-label mb-2 mt-2 px-2"><Trans>Item ID</Trans></label>
                                        <div className="col-sm-12 col-lg-9 px-2">
                                            <input type="text" className="form-control" id="ItemID" placeholder="Enter the Item ID" maxLength="18" value={this.state.Itemtxt} onKeyDown={this.keyPress} onChange={(e) => this.getItemSearchText(e)} />
                                            {this.state.Itemtxt ? <span className="search-cancel-header cursor-pointer" style={{ "right": "15px"}} onClick={() => this.ClearSearch()}></span> : null}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <button className="btn btn-primary custom-btn-primary primary-btn" onClick={this.SearchButtonClick}>Search</button>

                                    {/*[02/23/2022, PC_IH_01, WBW - 9, Dhevanesam R]*/}
                                    {/*<div className="col-md-4 float-left" style={{ "width": "25%" }}>
                                        <button className="btn btn-primary custom-btn-primary primary-btn" onClick={(e) => this.WOpopup()}> Select WO</button>
                                    </div>*/}
                                </div>
                            </div>

                        </div>

                        {this.state.GridArray.length > 0 ?
                            <div className="col-lg-12">
                                <div className="table-responsive">
                                    <table className="table ZEUS_Grid FOM-grid chk-ordertbl border-bottom">
                                        <thead>
                                            <tr>
                                                <th className="position-sort-icon" style={{ "width": "3px" }} />
                                                <th className="d-md-table-cell " style={{ "width": "10px" }}><Trans>Business unit</Trans></th>
                                                <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Item ID</Trans></th>
                                                <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Description</Trans></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.BindGridData()}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-md-12 my-3 float-left p-0">
                                    <button className="btn btn-primary custom-btn-primary primary-btn ml-3 float-right" onClick={(e) => this.UpdateButtonClick(e)}>Unhold</button>
                                    <button className="btn btn-primary custom-save-btn primary-btn ml-3 float-right" onClick={(e) => this.CancelButtonClick(e)}>Clear</button>
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn ml-3 float-right" onClick={(e) => this.CancelRedirectButtonClick(e)}>Cancel</button>
                                </div>
                                <div className="col-md-12 my-3 float-left p-0">
                                    {this.state.totalCount > 0 ?
                                        <div className="col-md-12 p-0">
                                            <span className="total-records mt-2 d-inline-block">
                                                <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.totalCount}</span>
                                            </span>
                                            {this.state.totalCount > this.state.ItemCount ? <ReactPaginate
                                                previousLabel={<span className="right-pagination-arrow" />}
                                                nextLabel={<span className="left-pagination-arrow" />}
                                                previousClassName={'page-item'}
                                                nextClassName={'page-item'}
                                                previousLinkClassName={'page-link'}
                                                nextLinkClassName={'page-link'}
                                                disabledClassName={'disabled'}
                                                breakLabel={'...'}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link'}
                                                pageCount={this.state.pageCount}
                                                marginPagesDisplayed={1}
                                                pageRangeDisplayed={2}
                                                onPageChange={this.handlePageClick}
                                                containerClassName={'custom-pagination pagination float-right'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link'}
                                                activeClassName={'active'}
                                                hrefBuilder={() => '#'}
                                                forcePage={this.state.PageNo - 1}
                                            /> : null}

                                        </div> : null}
                                </div>
                            </div> : <section className="site-undercontruction container text-center center-panel pt-4">
                                <div className="img-section">
                                    <img src="images/nosearch.jpg" alt="imagefile" />
                                </div>
                                <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                </p>
                            </section>}
                    </div>
                </div>
                <div className="modal" id="search-details-IH" data-backdrop="static" data-keyboard="false" >
                    <div className="modal-dialog modal-xl custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Search details</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={(e) => this.SearchPopUpclose(e)}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">

                                <div className="col-lg-12 float-left p-0">
                                    <div className="table-responsive">
                                        <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                            <thead>
                                                <tr>
                                                    <th className="d-md-table-cell "></th>
                                                    <th className="d-md-table-cell "><Trans>Business unit</Trans></th>
                                                    <th className="d-md-table-cell "><Trans>Item ID</Trans></th>
                                                    <th className="d-md-table-cell "><Trans>Description</Trans></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.BindSearchGridData()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-md-12 text-center float-left mb-2">
                                    <button className="btn btn-primary custom-btn-primary primary-btn ml-3 float-right px-4" data-dismiss="modal" onClick={(e) => this.PutOnHoldButtonClick(e)}><Trans>Put on hold</Trans></button>
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right mr-2 px-4" data-dismiss="modal" onClick={(e) => this.CancelPutOnHoldButtonClick(e)}><Trans>Clear</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="modal userid" id="WorkOrder" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog  custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1">WO#</h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.WOClose()}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="col-md-11 float-left my-5">
                                        <label className="float-left col-md-3 form-label catalog-label pl-0"><Trans>workorder_key</Trans><span> #</span></label>
                                        <div className="float-left col-md-9">
                                            <input type="text" className="form-control " placeholder="Enter work order number" id="WONUM" name="WorkOrderNo" />
                                            {this.state.WOmsg ? <span id="WOError" className="DropDown-Font-Size errorcolour"><Trans>Enter valid WO number</Trans></span> : null}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 text-center mb-2">

                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4 mr-2" id="WOOK" onClick={() => this.WOClick()}><Trans>Ok</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    };
}
export default withTranslation()(ItemHoldsComponent);